export enum DeviceTypes {
  DESKTOP = 'pc',
  TABLET = 'tablet',
  MOBILE = 'mobile',
  BOT = 'bot'
}

/**
 * Device classes that need for desktop view
 */
const desktopGroup = [DeviceTypes.DESKTOP, DeviceTypes.BOT];

const normalize = deviceClass => (deviceClass ? deviceClass.toLowerCase() : '');

export const isDesktop = (deviceClass: string): boolean => {
  return !deviceClass || desktopGroup.includes(normalize(deviceClass));
};

export const isMobile = (deviceClass: string): boolean => {
  return /mobile|iphone/.test(normalize(deviceClass));
};

export const isTablet = (deviceClass: string): boolean => {
  return /tablet|ipad/.test(normalize(deviceClass));
};
